import { Content } from '../../types';

export const benchakittiParkContent: Content = {
  title: "פארק בנצ'קיטי Benchakitti Park",
  imageUrl: '/images/thailand/benchakitti-park/benchakitti-park-wide.jpeg',
  introduction: `פארק בנצ'קיטי (Benchakitti Park) הינו פארק ציבורי במרכז בנגקוק, ברובע Khlong Toei, בסמוך לתחנות הרכבת התחתית (MRT) Queen Sirikit National Convention Center ו - Sukhumvit ולתחנת הרכבת העילית (BTS) Asok.
הפארק, הינו אחד מהריאות הירוקות המרכזיות והמרשימות ביותר בבנגקוק והינו ללא ספק מקום אידיאלי לקבוצות ו/או מטיילים הרוצים לנוח מהמולת העיר. הפארק נפרש ע"פ שטח עצום של כ-72 דונם, כאשר בשנים האחרונות הוא הורחב באופן משמעותי עם חיבור לשטחים ירוקים נוספים, מה שהופך אותו ל"פארק הירוק הגדול ביותר" במרכז העיר.`,
  sections: [
    {
      title: 'מה נמצא בפארק?',
      type: 'sub-headers',
      description: 'הפארק מציע מגוון אטרקציות ואזורים לבילוי ומנוחה:',
      content: [
        {
          subtitle: 'אגם מרכזי ומסלולים מסביבו',
          text: 'במרכז הפארק נמצא אגם גדול, מוקף במסלולי הליכה, ריצה ורכיבה על אופניים. זהו מקום פסטורלי עם נוף פתוח ותחושת רוגע, המחברת את המטיילים לטבע.',
        },
        {
          subtitle: 'גנים טרופיים ואזורי מדשאות',
          text: 'הפארק מציע גינות מעוצבות בסגנון תאילנדי, עם צמחייה מגוונת, פרחים צבעוניים ועצי דקל. זהו מקום מעולה להירגע או לצלם תמונות קבוצתיות.',
        },
        {
          subtitle: 'מסלולי אופניים והליכה נרחבים',
          text: 'ישנם שבילים ייעודיים לאורך כל הפארק לרוכבי אופניים ולמטיילים רגליים. המסלולים מסומנים ונוחים מאוד.',
        },
        {
          subtitle: 'תצפיות וגשרים',
          text: 'בשטח ההרחבה החדשה של הפארק, ישנם גשרים ותצפיות ייחודיות מעל לצמחייה, המאפשרים מבט פנורמי על האזור.',
        },
        {
          subtitle: 'אזורים לחובבי כושר',
          text: 'יש בפארק מתקני כושר חיצוניים ורצועות ריצה, כך שהינו מתאים לאנשים המעוניינים לשמור על פעילות גופנית גם בטיול.',
        },
        {
          subtitle: 'סביבה ידידותית למשפחות',
          text: 'הפארק כולל שטחים לילדים ובכלל זה, אזורים למשחקים, כך שמשפחות עם ילדים ייהנו כאן במיוחד.',
        },
      ],
    },
    {
      title: 'שעות פתיחת הפארק ומידע שימושי',
      type: 'sub-headers',
      description:
        'הפארק פתוח בין השעות 04:30 בבוקר ועד 22:00 בערב, כאשר, עקב מזג האוויר הטרופי והחם, הרי ששעות הבוקר המוקדמות והערב הן הטובות ביותר לבקר בו.',
      content: [
        {
          subtitle: 'טיפים למבקרים',
          text: 'מומלץ להביא מים, כובעים ותכשירי הגנה מהשמש. ניתן אף לשכור סירות פדלים קטנות לחוויה נוספת באגם.',
        },
        {
          subtitle: 'קרבה למוקדי עניין',
          text: 'הפארק קרוב מאוד לקניון Terminal 21 וכאמור אף לתחנות הרכבות העילית והתחתית, כך שניתן לשלב טיול בפארק עם קניות או ארוחה.',
        },
        {
          subtitle: 'חיבור לפארק לומפיני',
          text: 'לאחרונה אף נפתח שביל הולכי רגל ואופניים, באורך של כ - 1.3 ק"מ, המחבר את הפארק עם פארק לומפיני המוכר יותר, עליו נדבר בפוסט הבא.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, הפארק מצליח לשלב בין טבע ורוגע לבין העירוניות הסובבת אותו ובכך מספק חוויה יוצאת דופן במרכז בנגקוק וזאת, מעבר לעובדה שהינו מייצג את המחוייבות של הרשויות ליצירת מרחבים ירוקים בעיר ככלל ובמרכזה כפרט.`,
      type: 'text',
      isBold: true,
    },
  ],
};
